import axios from 'axios';
import Config from '../config';
/**
 * @type {AxiosInstance}
 */
const $axios = axios.create({
    baseURL: Config.apiBaseUrl,
});
export default $axios;
